'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowRepeatOutline = function TiArrowRepeatOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.7 12c0-0.1 0-0.2 0-0.3 0-1.4-0.6-2.6-1.5-3.6-0.9-0.9-2.2-1.4-3.5-1.4s-2.6 0.5-3.6 1.4l-4.8 4.9c-0.9-0.8-2-1.3-3.3-1.3h-1.7c-6.4 0-11.6 5.2-11.6 11.6 0 5.5 3.5 10.2 8.3 11.4 0 0.1 0 0.2 0 0.3 0 1.3 0.5 2.6 1.5 3.5 0.9 1 2.2 1.5 3.5 1.5s2.6-0.5 3.5-1.5l4.9-4.8c0.8 0.8 2 1.3 3.3 1.3h1.6c6.5 0 11.7-5.2 11.7-11.7 0-5.5-3.6-10.1-8.3-11.3z m-3.4 19.7h-1.6c-1 0-1.7-0.8-1.7-1.7s0.7-1.7 1.7-1.7h1.6c2.8 0 5-2.2 5-5s-1.8-5-4.1-5h-3.5l2.1 2.2c0.7 0.6 0.7 1.7 0 2.3-0.3 0.4-0.7 0.5-1.1 0.5s-0.9-0.1-1.2-0.5l-6.2-6.1 6.2-6.2c0.3-0.3 0.7-0.5 1.2-0.5s0.8 0.2 1.1 0.5c0.7 0.6 0.7 1.7 0 2.3l-2.1 2.2h3.5c4.1 0 7.5 3.7 7.5 8.3s-3.8 8.4-8.4 8.4z m1.3-11.7c1.1 0.3 2.1 1.7 2.1 3.3 0 1.9-1.5 3.4-3.4 3.4h-1.6c-1.5 0-2.7 0.9-3.1 2.1-0.1 0-6.2-6.2-6.2-6.2-0.7-0.6-1.5-0.9-2.4-0.9s-1.7 0.3-2.4 0.9-0.9 1.5-0.9 2.4c0 0.6 0.1 1.1 0.4 1.6-1.2-0.3-2.1-1.7-2.1-3.3 0-1.8 1.5-3.3 3.3-3.3h1.7c1.4 0 2.6-0.9 3.1-2.2l6.2 6.2c0.6 0.7 1.5 1 2.4 1s1.7-0.3 2.3-1 1-1.4 1-2.3c0-0.6-0.1-1.2-0.4-1.7z m-12.9-3.3c0 0.9-0.8 1.6-1.7 1.6h-1.7c-2.7 0-5 2.3-5 5s1.9 5 4.2 5h3.5l-2.2-2.1c-0.6-0.7-0.6-1.7 0-2.4 0.3-0.3 0.8-0.5 1.2-0.5s0.9 0.2 1.2 0.5l6.2 6.2-6.2 6.2c-0.3 0.3-0.8 0.5-1.2 0.5s-0.9-0.2-1.2-0.5c-0.6-0.7-0.6-1.7 0-2.4l2.2-2.1h-3.5c-4.1 0-7.5-3.8-7.5-8.4s3.7-8.3 8.3-8.3h1.7c0.9 0 1.7 0.7 1.7 1.7z' })
        )
    );
};

exports.default = TiArrowRepeatOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-repeat-outline.js
// module id = 1792
// module chunks = 0